<div class="dialog-header">
  <h3 class="dialog-title">{{ title }}</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="row-fx-legacy">
      <mat-form-field [appearance]="isNewLayout ? 'fill' : 'legacy'">
        <mat-label>{{ "input-reason" | translate }}</mat-label>
        <mat-select
          #select
          formControlName="reason"
          [multiple]="!isNewLayout"
          (selectionChange)="selectReason($event)"
        >
          <mat-option *ngFor="let reason of reasons" [value]="reason.value">
            {{ reason.name }}
          </mat-option>
        </mat-select>
        <mat-error
          translate
          *ngIf="
            form.get('reason').touched &&
            form.get('reason').hasError('required')
          "
          >required-reason</mat-error
        >
      </mat-form-field>
    </div>

    <div class="row-fx-legacy" *ngIf="showTextArea">
      <mat-form-field appearance="fill" class="custom-textarea-field">
        <mat-label>{{ "reason-description" | translate }}</mat-label>
        <textarea
          formControlName="otherReason"
          matInput
          [matTextareaAutosize]="!isNewLayout"
          rows="4"
          maxlength="255"
        ></textarea>
        <mat-error
          translate
          *ngIf="
            form.get('otherReason').touched &&
            form.get('otherReason').hasError('required')
          "
        >
          required-reason
        </mat-error>
        <mat-error
          translate
          *ngIf="
            form.get('otherReason').touched &&
            form.get('otherReason').hasError('minlength')
          "
        >
          another-reason-length</mat-error
        >
      </mat-form-field>
    </div>
  </form>
</div>

<div class="dialog-actions">
  <button
    *ngIf="isNewLayout"
    mat-button
    type="button"
    (click)="closeDialog(false)"
  >
    {{ "input-cancel" | translate }}
  </button>
  <button
    class="sample-button sample-button--primary"
    [disabled]="form.invalid"
    (click)="closeDialog(true)"
  >
    {{ "input-save" | translate }}
  </button>
</div>
